import styled from 'styled-components';
import colors from '../../../../../../../styles/themes/TCP/colors';

// eslint-disable-next-line import/prefer-default-export
export const Section = styled.section(
  ({
    theme,
    bopisNullResult,
    isHeaderScrollViewDisabled,
    isHeaderStickyClassPresent,
    stickyHeaderHeight,
    headerMiddleNavHeight,
    isGlobalHeaderRedesignEnabled,
  }) => `
    ::-webkit-scrollbar { width: 0 !important }
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
    padding: 0 19px;
    border-right: 2px solid #E5E5E5;
    color:${theme.black};
    position: sticky;
    top: 120px;
    transition: all 0.3s ease-in-out;
    ${
      bopisNullResult
        ? 'height:100%;'
        : 'max-height:calc(100vh - 120px);height: calc(100vh - 120px);'
    }
    overflow-y: auto;
    ${
      !isGlobalHeaderRedesignEnabled && isHeaderScrollViewDisabled
        ? `
      @media ${(props) => props.theme.mediaQuery.large} {
      ${
        isHeaderStickyClassPresent
          ? `top: ${stickyHeaderHeight}px;max-height:calc(100vh - ${stickyHeaderHeight}px);height: calc(100vh - ${stickyHeaderHeight}px);transform:translateY(0);`
          : `top: 40px;max-height:calc(100vh - 40px);height: calc(100vh - 40px);translateY(40px);`
      }
      }
    `
        : ``
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      ${
        isGlobalHeaderRedesignEnabled
          ? `
      @media ${(props) => props.theme.mediaQuery.large} {
        transition: top 0.3s ease;
        top: ${
          parseInt(headerMiddleNavHeight, 10) + 10
        }px;max-height:calc(100vh - ${headerMiddleNavHeight}px);height: calc(100vh - ${headerMiddleNavHeight}px);transform:translateY(0);
      }
      `
          : ``
      }
    }
`
);

export const LoadCount = styled.div(
  (props) => `
  font-size: 16px;
  font-weight: 800;
  padding: 17px 0;
  text-align: center;
  .count-section,.items-count-content {
    text-align: left !important;
  }
  @media ${props.theme.mediaQuery.mediumMax} {
    padding: 0 ;
  }
  @media ${props.theme.mediaQuery.large} {
    ${props.categoryPlp ? 'border-top: 1px solid rgba(146, 146, 146, 0.4);' : ''}
    ${
      props.categoryPlp && !props.isBopisFilterEnabled
        ? 'border-bottom: 1px solid rgba(146, 146, 146, 0.4);'
        : ''
    }
  }
  `
);

export const CategoryHeading = styled.p(
  () => `
  font-size: 16px;
  font-family: Nunito;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.64px;
  color: ${colors.PRIMARY.DARK};
  margin-bottom: 16px;
  `
);
